import * as SelectSegments from './components/SelectSegments.css';

export const defaultTheme = {
	SelectSegments
};

export default defaultTheme;
